import { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getTeamsSuggestions, ITeam } from 'wisestep-api';
import { WsAutoComplete } from 'wisestep-base';

import { getFilterObj } from '../../../features/jobs/helper';
import WsFilterProps from '../models/WsFilterProps';

//If facing issue with team names state consider passing defaultObjects from your form's state
const WsTeamFilter = ({
  name,
  placeHolder = 'filter by team names',
  label = '',
  requireTeam = false,
  multiple = true,
  defaultValue = [],
  focused = false,
  defaultObjects = [],
  onSelect,
  onSelectMultipleValues,
}: WsFilterProps) => {
  const [teams, setClients] = useState<string[]>([]);
  const teamsSuperList = useRef<ITeam[]>(defaultObjects ?? []);
  const abortControllerRef = useRef<AbortController | undefined>();
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | undefined>();

  const { setValue } = useFormContext();

  const onClientNameInputKey = async (team: string, signal?: AbortSignal) => {
    const result = await getTeamsSuggestions(team, { signal });
    const newData = result?.data?.filter(
      (item) => !teamsSuperList.current.some((i) => i.id === item.id)
    );
    teamsSuperList.current = [...teamsSuperList.current, ...newData];
    if (teamsSuperList.current?.length > 0) {
      const teamNamesList: string[] = teamsSuperList.current?.map((item) => item.name) ?? [];
      setClients(teamNamesList);
    }
  };

  const teamFetchScheduler = (team: string) => {
    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    abortControllerRef.current?.abort();

    abortControllerRef.current = new AbortController();
    timeoutIdRef.current = setTimeout(
      () => onClientNameInputKey(team, abortControllerRef.current?.signal),
      300
    );
  };

  const onClientNameSelection = (teamNames: string[]) => {
    if (!requireTeam) {
      const teams = teamsSuperList.current.filter((i) => teamNames.includes(i.name));
      setValue(name, teams);
      onSelectMultipleValues && onSelectMultipleValues([]);
    } else {
      setValue(name, getFilterObj(teamsSuperList.current, teamNames)[0]);
    }
    onSelect && onSelect(teamNames?.[0]);
  };

  return (
    <WsAutoComplete
      size="small"
      onValueEnter={teamFetchScheduler}
      onTagsChange={onClientNameSelection}
      placeholder={placeHolder}
      initialValue={defaultValue}
      optionsInStringArray={teams}
      multiple={multiple && !requireTeam}
      freeSolo={false}
      name={name}
      label={label}
      focused={focused}
    />
  );
};

export default WsTeamFilter;
